"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPLACE_BUTTON = void 0;
const REPLACE_BUTTON = exports.REPLACE_BUTTON = 'replace-button';
